import React from "react";

export default function (className, options) {
  return Component =>
    class C extends React.Component {
      UNSAFE_componentWillMount() {
        const classNames = className.split(" ");

        classNames.map(cls => document.body.classList.add(cls));
      }

      componentWillUnmount() {
        if (options && options.disableRestore) {
          return;
        }
        const classNames = className.split(" ");

        classNames.map(cls => document.body.classList.remove(cls));

        if (options && options.restoreClassName) {
          const restoreClassNames = options.restoreClassName.split(" ");

          restoreClassNames.map(cls => document.body.classList.remove(cls));
        }
      }

      render() {
        return <Component {...this.props} />;
      }
    };
}
